import { TipoDeRecurso } from "@/models/Recurso";
import { tituloDaToolbarPeloNomeDaRota } from "@/shareds/router-shareds";
import { RouteConfig } from "vue-router";

const rotasDeCriarCartaDeCorrecao: RouteConfig[] = [
	{
		path: 'criar-carta-correcao',
		name: 'Criar Carta de Correção',
		components: {
			default: () =>
				import('@/views/application/documentos-fiscais/TelaDeCriacaoDeCartasDeCorrecao.vue'),
			toolbar: () =>
				import('@/components/layout/AppToolbarComTitulo.vue'),
		},
		props: { toolbar: tituloDaToolbarPeloNomeDaRota },
		meta: {
			recurso: 'criar-carta-correcao' as TipoDeRecurso,
		},
	},
]

export default rotasDeCriarCartaDeCorrecao